<form (submit)="submit($event)"  fxLayout="row" fxLayoutGap="10px">
  <section fxFlex="10">
    <mat-label>payment plan:</mat-label>
    <mat-select id="contractType" [(value)]="planType">
      <mat-option *ngFor="let paymentType of possiblePaymentTypes" [value]="paymentType.value">
        {{paymentType.label}}
      </mat-option>
    </mat-select>
  </section>

  <mat-form-field appearance="fill" fxFlex="20">
    <mat-label>amount</mat-label>
    <input matInput id="amount" value="{{amount}}"
           (input)="amount= toNumber($event.target.value)"
    />
  </mat-form-field>

  <mat-form-field appearance="fill" fxFlex="10" id="startAtMonth">
    <mat-label>start at month</mat-label>
    <input matInput
           value="{{startAtMonth}}"
           (input)="startAtMonth= toNumber($event.target.value)"
    />
  </mat-form-field>


  <div fxFlex="20">
    <button type="submit" mat-raised-button color="primary">calculate</button>
  </div>
  <div fxFlex="10">
    <button type="button"
            mat-fab color="accent"
            matTooltip="Remove Payment"
            (click)="remove()">-P</button>
  </div>
</form>
